// src/Firebase/Config.js
import { getAuth } from "firebase/auth";

// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "NEXT_PUBLIC_FIREBASE_API_KEY",
  authDomain: "j3xinnovation.com",
  projectId: "j3xinnovation",
  storageBucket: "j3xinnovation.firebasestorage.app",
  messagingSenderId: "428781987524",
  appId: "1:428781987524:web:2bf6988169acef6e5c8b91",
  measurementId: "G-C6C71RCNRE",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firestore
export const db = getFirestore(app);

// Initialize Storage
export const storeage = getStorage(app); // Initialize Firebase Storage and export it

export const auth = getAuth(app);

export default app;
